/* eslint-disable */
import React from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import Fade from 'react-reveal/Fade'
import { useTranslation } from "react-i18next";

import CardBox from '../../components/card-box'
import { TitleOne, TextBodyOne } from '../../components/text'
import icServiceTrain from '../../static/icons/ic-service-train.svg'
import icTerampil from '../../static/icons/ic-terampil.svg'
import icBerpengalaman from '../../static/icons/ic-berpengalaman.svg'
import { Style } from './service-massage.styles'

const ServiceMassage = () => {
  const { t } = useTranslation();

  return (
    <Style>
      <Grid>
        <Row>
          <Col
            sm={12}
            xs={12}
            lg={12}
            className="column-margin"
          >
            <TitleOne display="block" align="center">
              {t('pageBodyMassageJakarta.part17')}
            </TitleOne>
            <TextBodyOne display="block" align="center">
              {t('pageBodyMassageJakarta.part18')}
            </TextBodyOne>

            <Fade left>
              <div className="page-line">
                <div />
              </div>
            </Fade>
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={4} xs={12} lg={4} className="bottom-margin" >
            <CardBox
              imageResponsiveMobile={true}
              image={icServiceTrain}
              title={t('pageBodyMassageJakarta.part19')}
              desc={t('pageBodyMassageJakarta.part20')}
            ></CardBox>
          </Col>
          <Col sm={12} md={4} xs={12} lg={4} className="bottom-margin">
            <CardBox
              image={icTerampil}
              imageResponsiveMobile={true}
              title={t('pageBodyMassageJakarta.part21')}
              desc={t('pageBodyMassageJakarta.part22')}
            ></CardBox>
          </Col>
          <Col sm={12} md={4} xs={12} lg={4} className="bottom-margin">
            <CardBox
              image={icBerpengalaman}
              imageResponsiveMobile={true}
              title={t('pageBodyMassageJakarta.part23')}
              desc={t('pageBodyMassageJakarta.part24')}
            ></CardBox>
          </Col>
        </Row>
      </Grid>
    </Style>
  )
}

export default ServiceMassage
